<template>
  <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
    <form @submit.prevent="handleSubmit(submit)">
      <div class="form-group row">
        <div class="col-12">
          <reg-input-text
            v-if="fields[0]"
            label="Email Address"
            type="email"
            :form="form"
            :field="fields[0]"
            placeholder="Enter Email Address"
            formGroupClass=""
            :rules="{ required: fields[0].required, email: true }"
          />

          <!-- :api-errors="apiErrors" -->

          <div class="d-flex justify-content-between validation-row mt-2 mb-2 flex-wrap"
            :class="showOtpSectionEmail ? 'grp-email-otp-validation mb-3 col-md-8 col-sm-11' : 'mb-2'"
          >
            <a
              v-if="showOtpSectionEmail"
              href="#"
              class="validate-via-otp-link validate-btn p-0"
              @click.prevent="openOtpModal('email')"
            >
              TO CONTINUE, PLEASE CLICK HERE TO VERIFY YOUR EMAIL.
            </a>
          </div>

          <div v-if="emailMsg" class="contact-message-container form-group">
            <div :class="['validate-message mt-2', emailValidationMessage.type]">
              <div :class="['message-indicator', `${emailValidationMessage.type}-indicator`]"></div>
              <span class="message-text">
                <strong :class="`${emailValidationMessage.type}-text`">
                  {{ emailValidationMessage.title }}
                </strong>
                -
                {{ emailValidationMessage.message }}
              </span>
            </div>
          </div>
        </div>

        <!-- <button
        @click="openModal(fields[0].field_name)"
          class="button-verify-email"
          v-if="apiErrors && apiErrors[fields[0].field_name]"
        >
          Verify Your Email
        </button> -->
        <reg-input-text
          v-if="fields[1]"
          label="Password"
          type="password"
          :form="form"
          :field="fields[1]"
          placeholder="Password"
          formGroupClass="col-xxl-6 col-xl-6 col-lg-6 col-md-6 mb-4"
          :rules="{ required: fields[1].required }"
        >
          <template v-slot:appendIcon>
            <eye-button
              id="password"
              class-name="toggle-password-icon"
              :hide-on-default="true"
              type="text"
            />
          </template>
          <template v-slot:shortMessage>
            <!-- <span
              class="short-msg"
              v-if="!(apiErrors && apiErrors[fields[1].field_name])"
            >
            Password should be at least 8 characters long and include uppercase, lowercase, number & special character.
            </span> -->
          </template>
        </reg-input-text>

        <reg-input-text
          v-if="fields[2]"
          label="Confirm Password"
          type="password"
          :form="form"
          :field="fields[2]"
          placeholder="Confirm Password"
          :api-errors="apiErrors"
          formGroupClass="col-xxl-6 col-xl-6 col-lg-6 col-md-6 mb-4"
          :rules="{ required: fields[2].required }"
        >
          <template v-slot:appendIcon>
            <eye-button
              id="password_confirmation"
              class-name="toggle-password-icon"
              :hide-on-default="true"
              type="text"
            />
          </template>
        </reg-input-text>
      </div>
      <div v-if="passwordMsg" class="contact-message-container form-group">
        <div :class="['validate-message', passwordValidationMessage.type]">
          <div :class="['message-indicator', `${passwordValidationMessage.type}-indicator`]"></div>
          <span class="message-text">
            <strong :class="`${passwordValidationMessage.type}-text`">
              {{ passwordValidationMessage.title }}
            </strong>
            -
            {{ passwordValidationMessage.message }}
          </span>
        </div>
      </div>

      <div class="action-btn split-action mt-5">
        <button class="button-black" @click="backHandler" type="button">Back</button>
        <div class="action-next">
          <button class="button-green" @click.prevent="saveAndContinue" type="button">
            Save & Continue Later
          </button>
          <button class="button-blue" type="submit">Next</button>
        </div>
      </div>
    </form>

    <!-- <verify-phone-email-modal /> -->
    <otp-verification-modal
      v-if="showOtpModal"
      v-model="showOtpModal"
      :identifier="contactInfo"
      :identifierTypeText="otpType"
      :field="field"
      @save="handleVerificationResult"
      @close="closeOtpModal"
    />
    <!-- <verify-phone-email-modal :inputType="inputType" :inputValue="inputValue"/> -->
  </ValidationObserver>
</template>
<script>
  import Cookies from 'js-cookie';
  import axios from '@/utils/regAxios';
  import Screenshot from '@/utils/screenshot';
  // import VerifyPhoneEmailModal from "../../Member/modal/VerifyPhoneEmailModal.vue";
  import OtpVerificationModal from '@/components/common/OtpVerificationModal.vue';

  export default {
    name: 'LoginForm',
    components: {
      OtpVerificationModal,
    },
    props: {
      fields: {
        required: true,
      },
      form: {
        required: true,
      },
    },
    data: () => ({
      apiErrors: null,
      inputType: null,
      inputValue: null,
      isOtpModalVisible: false,

      showOtpModal: false,
      contactInfo: null,
      otpType: null,
      emailMsg: false,
      phoneMsg: false,
      emailValidationMessage: null,
      phoneValidationMessage: null,
      validationStatus: null,
      showOtpSectionEmail: false,
      showOtpSectionPhone: false,
      skipEmailVerification: false,

      skipPhoneVerification: false,
      emailVerified: false,
      phoneVerified: false,
      showOtpSectionDisplayEmail: false,
      dispalyEmailMsg: false,
      displayEmailValidationMessage: null,
      passwordMsg: false,
      passwordValidationMessage: null,
      field: null,
    }),
    mounted() {
      if (this.inputValue) {
        this.contact = this.inputValue; // Ensure field is filled
      }
    },
    methods: {
      removeTimer() {
        Cookies.remove('otp_logged_time');
      },

      checkCookies() {
        if (Cookies.get('otp_logged_time') !== undefined) {
          return true;
        } else {
          return false;
        }
      },

      getTimer() {
        if (this.checkCookies()) {
          // this.$notify('Please wait for 10 minutes before sending another OTP', 'error')
          return false;
        }

        let cookieValue = Cookies.get('otp_logged_time');
        let remaining = Math.round((cookieValue - new Date().getTime()) / 1000);
        this.remaningSecond = isNaN(remaining) ? 0 : remaining;

        if (remaining) {
          // this.$notify('Please wait for 10 minutes before sending another OTP', 'error')
          return false;
        } else {
          return true;
        }
      },

      handleVerificationResult(result) {
        if (result.verified) {
          // Handle successful verification
          if (result.type === 'email' && result.field === 'email') {
            this.emailMsg = true;
            this.skipEmailVerification = true;
            this.form.skip_validation_email = 1;
            this.emailValidationMessage = {
              type: 'success',
              title: 'Success',
              message: 'Your phone has been verified!',
            };
            this.showOtpSectionEmail = false;
          }
        }
      },

      async sendOtp() {
        if (!this.getTimer()) {
          // this.$notify('Please wait for 10 minutes before sending another OTP', 'error')
          return;
        }

        try {
          let url = process.env.VUE_APP_API_URL_V2 + `send-group-otp`;
          axios
            .post(url, {
              contact: this.contactInfo,
              enrollment_id: this.$store.getters.regTempId,
              type: this.otpType,
            })

            .then((res) => {
              if (res.data.success === true || res.data.status === 'success') {
                this.$notify('OTP sent successfully!');
              } else {
                this.$notify(res.data.message || 'Failed to send OTP. Please try again.', 'error');
                // this.showOtpSection = false;
              }
            })

            .catch((err) => {
              this.$notify(err.response.data.message, 'error');
            });
        } catch (error) {
          this.$notify('Failed to send OTP. Please try again.', 'error');
          // this.showOtpSection = false;
          console.error('OTP send error:', error);
        }
      },

      saveAndContinue() {
        this.$emit('onOpenSaveAndContinue', this.form);
      },
      // openModal(fieldName) {
      //   this.inputType = fieldName;
      //   this.inputValue = this.form[fieldName];
      //   this.isOtpModalVisible = true;

      //   if (this.apiErrors && this.apiErrors[fieldName]) {
      //     this.$set(this.apiErrors, fieldName, null);
      //   }
      // },

      openOtpModal(type) {
        if (type === 'email' && !this.form.email) {
          this.$notify('Please enter an email first.', 'warning');
          return;
        }
        if (type === 'email') {
          this.field = 'email';
          this.contactInfo = this.form.email;
          this.otpType = type;
          this.sendOtp();
        }
        // this.contactInfo = type === "email" ? this.form.email : this.form.cell_phone;
        this.showOtpModal = true;
      },

      // to close the otp modal
      closeOtpModal() {
        this.showOtpModal = false;
      },

      backHandler() {
        this.$emit('onBackHandler');
      },
      async submit() {
        this.form.registration_id = this.$store.getters.regTempId;
        let loader = this.$loading.show();
        let formData = this.form;
        Screenshot.captureScreenShot(Screenshot.regScreenShotSelector)
          .then((res) => {
            if (res) {
              formData['screenshot'] = res;
            }
          })
          .finally(() => {
            loader.hide();
            const url = 'register/login-info';
            this.save(url, formData);
          });
      },
      async save(url, payload) {
        this.emailMsg = false;
        this.showOtpSectionEmail = false;
        this.emailValidationMessage = null;
        let loader = this.$loading.show();
        try {
          let res = await axios.post(url, payload);
          if (res.data.statusCode == 200) {
            this.$emit('onSuccess');
            this.removeTimer();
            this.form.skip_validation_email = 0;
          }
        } catch (err) {
          this.removeTimer();

          if (err.response.data.statusCode == 422) {
            this.apiErrors = err.response.data.errors;

            if (
              this.apiErrors.email &&
              this.apiErrors.email.includes('Email Already Exists.')
            ) {
              // this.showOtpSectionEmail = true;
              this.emailMsg = true;
              this.emailValidationMessage = {
                type: 'error',
                title: 'Caution',
                message: 'Email is already in use',
              };
              // this.$notify("Invalid Email - Please validate via OTP", "error");
            } else if (
              this.apiErrors.email && (
              this.apiErrors.email.includes('Email is invalid - Validated using Neverbounce API')
              || this.apiErrors.email.includes('Email is invalid.')
              )
            ) {
              this.showOtpSectionEmail = true;
              this.emailMsg = true;
              this.emailValidationMessage = {
                type: 'error',
                title: 'Caution',
                message: 'Invalid Email - Please validate via OTP',
              };
              // this.$notify("Invalid Email - Please validate via OTP", "error");
            }

            if (this.apiErrors.password) {
              this.passwordMsg = true;
              this.passwordValidationMessage = {
                type: 'error',
                title: 'Error',
                message: this.apiErrors.password[0],
              };
            }
            this.$notify('Please enter the valid details', 'error');

            // setTimeout(() => {
            //     if (this.apiErrors && this.fields && this.fields.length > 0) {
            //       const fieldsToKeep = [
            //         this.fields[0].field_name,
            //         // this.fields[3].field_name,
            //       ];

            //       const newErrors = { ...this.apiErrors };

            //       // Remove errors for all fields except fields[0] and fields[3]
            //       Object.keys(newErrors).forEach((key) => {
            //         if (!fieldsToKeep.includes(key)) {
            //           delete newErrors[key];
            //         }
            //       });

            //       this.apiErrors = Object.keys(newErrors).length
            //         ? newErrors
            //         : null;
            //     }
            //   }, 5000);
          } else {
            this.$notify('Something went wrong, Please try again later ', 'error');
          }
        } finally {
          loader.hide();
        }
      },
    },

    created() {
      this.removeTimer();
      if (!this.$store.getters.regTempId) {
        this.backHandler();
      }
    },
    watch: {
      'form.email': {
        handler(newVal, oldVal) {
          if (newVal !== oldVal) {
            this.form.skip_validation_email = 0;
            this.removeTimer();
            this.emailMsg = false;
            this.showOtpSectionEmail = false;
            this.emailValidationMessage = null;
            this.emailVerified = false;
          }
        },
        immediate: true,
      },

      'form.password': {
        handler(newVal, oldVal) {
          if (newVal !== oldVal) {
            this.passwordMsg = false;
            this.passwordValidationMessage = null;
          }
        },
        immediate: true,
      },

      'form.password_confirmation': {
        handler(newVal, oldVal) {
          if (newVal !== oldVal) {
            this.passwordMsg = false;
            this.passwordValidationMessage = null;
          }
        },
        immediate: true,
      },
    },
  };
</script>

<style>
  .validate-message {
    display: flex;
    align-items: center;
    background-color: #fff;
    border-radius: 4px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    padding: 0.75rem 1rem;
    position: relative;
    margin-bottom: 0.75rem;
  }

  .message-indicator {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 4px;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
  }

  .message-text {
    flex-grow: 1;
    margin-left: 0.5rem;
    color: #495057;
  }

  .error-text {
    color: #dc3545;
    font-size: 0.875rem !important;
  }

  .success-text {
    color: #28a745;
  }

  .warning-text {
    color: #856404;
  }

  .error-indicator {
    background-color: #dc3545;
  }

  .success-indicator {
    background-color: #28a745;
  }

  .warning-indicator {
    background-color: #ffc107;
  }

  .button-verify-email {
    margin-top: 0;
    margin-bottom: 5px;
    font-size: 16px;
    border: none;
    background-color: transparent;
    color: rgb(5, 5, 139);
    text-decoration: underline;
    text-align: start;
  }

  .grp-email-otp-validation {
    border: 2px solid #e31717;
    padding: 5px;
    padding-left: 15px;
  }
  .grp-email-otp-validation:hover {
    border: 2px solid #a50e0e;
    box-shadow: #eb2a2a;
    background-color: aliceblue;
    cursor: pointer;
  }
</style>
